<template>
  <v-autocomplete
    outlined
    dense
    :items="entries"
    :loading="loading"
    label="Select Role"
    :value="value"
    @input="emitVal"
    item-text="name"
    item-value="id"
    v-bind="$attrs"
  ></v-autocomplete>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters("ROLE", {
      loading: "GET_LOADING",
    }),
    userRole: {
      get() {
        return this.$store.getters["ACCOUNT/GET_USER_ROLE"];
      },
    },
    entries: {
      get() {
        let entries = this.$store.getters["ROLE/GET_ENTRIES"];
        
        // if (this.userRole !== "SuperAdmin") {
        //   return entries.filter((entry) => entry.name !== "Admin" && entry.name !== "SuperAdmin");
        // }

        return entries;
      },
    },
  },
  methods: {
    emitVal(val) {
      this.$emit("input", val);
    },
  },
  mounted() {
    if (!this.entries.length) this.$store.dispatch("ROLE/GET");
  },
};
</script>
